<template>
  <div id="animateList">
    <div id="box" ref="box">
      <div
        id="con1"
        ref="con1"
        :class="{ anim: animate == true }"
        @mouseenter="mEnter"
        @mouseleave="mLeave"
      >
        <div
          v-for="(item, i) in List"
          :key="i"
          class="flex box flex-between item-center mb20"
          :style="{ color: colorStyle }"
        >
          <div class="mr10 flex item-center">
            <div class="head-portrait mr10">
              <img
                :src="
                  item.wechatAvatar ||
                    'https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2098.png'
                "
                alt=""
              />
            </div>
            <div class="mr10">
              {{ phoneEmailShow(item.memberMobile) }}
            </div>
          </div>

          <div>{{ item.memberName }}</div>
          <div>获得 {{ item.prizeLevel }}</div>
        </div>

        <!-- <div>
          <div
            v-for="(item, i) in List"
            :key="i"
            class="flex box flex-between item-center mb20"
            :style="{ color: colorStyle }"
          >
            <div class="mr10 flex item-center">
              <div class="head-portrait mr10">
                <img :src="item.wechatAvatar" alt="头像" />
              </div>
              <div class="mr10">
                {{ phoneEmailShow(item.memberMobile) }}
              </div>
            </div>

            <div>{{ item.memberName }}</div>
            <div>获得 {{ item.prizeLevel }}</div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { phoneEmailShow } from "@/utils/utils";
export default {
  name: "animateList",
  props: {
    List: {
      type: Array,
      default: () => []
    },
    colorStyle: {
      type: String,
      default: "#5d00e3"
    }
  },
  data() {
    return {
      ulLeftTrun: 0, //移动参数
      phoneEmailShow,
      animate: false,
      prizeUlHeightTrun: 0
    };
  },
  mounted() {
    this.timer = setInterval(this.scroll, 1000);
    // this.prizeUlHeightTrun = this.$refs.box.clientHeight;
    // this.timesTrun = requestAnimationFrame(this.animateTrun);
  },
  methods: {
    animateTrun() {
      requestAnimationFrame(this.animateTrun);
      this.changeAnimationTrun();
    },
    // 编写动画
    changeAnimationTrun() {
      if (this.ulLeftTrun == this.prizeUlHeightTrun) {
        this.ulLeftTrun = 0;
      } else {
        this.ulLeftTrun += 1;
      }
    },
    scroll() {
      // console.log(
      //   "this.$refs.con1.clientHeight: ",
      //   this.$refs.con1.clientHeight
      // );
      // console.log("this.$refs.box.clientHeight: ", this.$refs.box.clientHeight);
      if (this.$refs.con1.clientHeight > 600) {
        let that = this;
        that.$refs.con1.style.marginTop = "30px";

        that.animate = !that.animate;
        setTimeout(function() {
          that.List.unshift(that.List[that.List.length - 1]);
          that.List.pop();
          // that.List.push(that.List[0]);
          // that.List.shift();
          that.$refs.con1.style.marginTop = "0px";
          that.animate = !that.animate; // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
        }, 500);
      }
    },
    mEnter() {
      clearInterval(this.timer);
    },
    mLeave() {
      this.timer = setInterval(this.scroll, 3000);
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    cancelAnimationFrame(this.timesTrun); //清理原生的监听
  }
};
</script>

<style scoped lang="scss">
#box {
  height: calc(100vh - 265px);
  line-height: 30px;
  overflow: hidden;
  transition: all 0.5s;
  color: #ffffff;
}
.anim {
  transition: all 0.5s;
}
#con1 li {
  list-style: none;
  line-height: 30px;
  height: 30px;
}
.head-portrait {
  width: 38px;
  height: 38px;
  img {
    width: 100%;
    border-radius: 50%;
  }
}
.box {
  // color: #5d00e3;
  font-size: 24px;
  font-weight: 500;
}
</style>
